// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
export const environment = {
  production: true,
  environment: ($ENV && $ENV.ENVIRONMENT) || '',
  config: {
    tenant: ($ENV && $ENV.tenant) || '',
    clientId: ($ENV && $ENV.clientId) || '',
    instance: 'https://login.microsoftonline.com/',
    cacheLocation: 'localStorage',
    redirectUri: window.location.origin + '/location-picker',
    postLogoutRedirectUri: window.location.origin + '/location-picker',
    authority: ($ENV && $ENV.authority) || '',
    validateAuthority: true,
    navigateToLoginRequestUrl: true
  },

  SPCAPIBaseURL: ($ENV && $ENV.SPCAPIBaseURL) || '',
  SPCAPICIBaseURL: ($ENV && $ENV.SPCAPICIBaseURL) || '',
  NGTWBaseURL: ($ENV && $ENV.NGTWBaseURL) || '',
  masterConfig: ($ENV && $ENV.masterConfig) || '',
  dfosUrl: ($ENV && $ENV.dfosUrl) || '',
  blobURL: ($ENV && $ENV.blobURL) || '',
  subscriptionKey: ($ENV && $ENV.subscriptionKey) || '',
};

// export const environment = {
//   production: false,
//   config: {
//     tenant: 'f66fae02-5d36-495b-bfe0-78a6ff9f8e6e',
//     clientId: '00d7abcc-2027-49d3-8d81-d9f72660fb66',
//     instance: 'https://login.microsoftonline.com/',
//     cacheLocation: 'localStorage',
//     redirectUri: window.location.origin + '/location-picker',
//     postLogoutRedirectUri: window.location.origin + '/location-picker',
//     authority: 'https://login.microsoftonline.com/f66fae02-5d36-495b-bfe0-78a6ff9f8e6e/',
//     validateAuthority: true,
//     navigateToLoginRequestUrl: true
//   },
//   //SPCAPIBaseURL: 'https://spc-dev.unilever.com/spcapi/',
//   SPCAPIBaseURL: 'https://spcapi-dev-aks.df.unilever.com/spcapi/',
//   SPCAPICIBaseURL: 'https://spcodlapi-dev-aks.df.unilever.com/spcapi/',
//   NGTWBaseURL: 'https://ngtw-dev.unilever.com/ngtwapi/',
//   masterConfig: 'https://masterconfigurator-dev.unilever.com/mconfapi/',
//   dfosUrl: 'https://dfos-dev.unilever.com/api/',
//   blobURL: 'https://bienospcd57834webstorage.blob.core.windows.net/devexceltemplate/',
//   subscriptionKey: '',
// };

// export const environment = {
//   production: true,
//   config: {
//     tenant: 'f66fae02-5d36-495b-bfe0-78a6ff9f8e6e',
//     clientId: '0f215a82-2378-4b3a-a925-48742d22723f',
//     instance: 'https://login.microsoftonline.com/',
//     cacheLocation: 'localStorage',
//     redirectUri: window.location.origin + '/',
//     postLogoutRedirectUri: window.location.origin + '/',
//     authority: 'https://login.microsoftonline.com/f66fae02-5d36-495b-bfe0-78a6ff9f8e6e/',
//     validateAuthority: true,
//     navigateToLoginRequestUrl: true
//   },
//   SPCAPIBaseURL: 'https://spc-ppd.df.unilever.com/spcapi/',
//   NGTWBaseURL: 'https://ngtw-ppd.unilever.com/ngtwapi/',
//   masterConfig: 'https://masterconfigurator-ppd.unilever.com/mconfapi/',
//   dfosUrl: 'https://dfos-masterdata-ppd.df.unilever.com/api/',
//   blobURL: 'https://bienospcq57835webstorage.blob.core.windows.net/ppdexceltemplate/',
//   subscriptionKey: ''
// };




// export const environment = {
//   production: true,
//   config: {
//     tenant: 'f66fae02-5d36-495b-bfe0-78a6ff9f8e6e',
//     clientId: '0c4a8941-e08e-423a-9669-54683beee475',
//     instance: 'https://login.microsoftonline.com/',
//     cacheLocation: 'localStorage',
//     redirectUri: window.location.origin + '/',
//     postLogoutRedirectUri: window.location.origin + '/',
//     authority: 'https://login.microsoftonline.com/f66fae02-5d36-495b-bfe0-78a6ff9f8e6e/',
//     validateAuthority: true,
//     navigateToLoginRequestUrl: true
//   },
//   SPCAPIBaseURL: 'https://spc-qa.unilever.com/spcapi/',
//   //SPCAPIBaseURL: 'https://spcapi-dev-aks.df.unilever.com/spcapi/',
//   NGTWBaseURL: 'https://ngtw-qa.unilever.com/ngtwapi/',
//   masterConfig: 'https://masterconfigurator-qa.unilever.com/mconfapi/',
//   dfosUrl: 'https://dfosconfigurator-ppd.df.unilever.com/api/',
//   blobURL: 'https://bienospcq57835webstorage.blob.core.windows.net/qaexceltemplate/',
//   subscriptionKey: ''
// };

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
